// extracted by mini-css-extract-plugin
export var chip = "_cx-0";
export var filterDropdown = "_cx-5";
export var filterItem = "_cx-6";
export var icon = "_cx-1";
export var removeButton = "_cx-3";
export var removeIcon = "_cx-4";
export var separator = "_cx-2";